import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import store from './store/index.js'
import Clipboard from 'v-clipboard'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import { DataTables, DataTablesServer } from 'vue-data-tables'
import PortalVue from 'portal-vue'

import { mapGetters } from 'vuex'

export const eventBus = new Vue()

Vue.config.productionTip = false

Vue.use(Clipboard)
Vue.use(ElementUI)
locale.use(lang)
Vue.use(DataTables)
Vue.use(DataTablesServer)
Vue.use(PortalVue)

Vue.mixin({
  data() {
    return {
      host: process.env.VUE_APP_HOST_BACKEND,
      limeHost: process.env.VUE_APP_LIME_HOST,
      reporttool: process.env.VUE_APP_REPORT_TOOL,
      media: process.env.VUE_APP_MEDIALIBRARY,
      owQuestions: process.env.VUE_APP_QUESTION,
      owQuestionsTestLink: process.env.VUE_APP_OW_QUESTIONS_TEST_LINK,
      imageURL: 'https://static-owsurvey.s3.amazonaws.com/',
      imageURLTemplates: process.env.VUE_APP_IMAGE_URL_TEMPLATES,
    }
  },

  computed: {
    ...mapGetters(['languageSurvey']),

    language() {
      return this.languageSurvey
    },
  },

  methods: {
    addUser(data) {
      const token = this.$store.getters.token

      data.append('token', token)
    },

    addSurvey(data) {
      const survey = this.$store.getters.survey
      data.append('surveyname', survey.name)
      data.append('s_id', survey.id_)
    },

    parseTranslation(key, ...values) {
      const translation = this.translations?.[this.language]?.[key]

      if (typeof translation === 'function') return translation(...values)

      return translation
    },
  },
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

// eslint-disable-next-line
function initFreshChat() {
  window.fcWidget.init({
    token: process.env.VUE_APP_FRESHCHAT_TOKEN,
    host: process.env.VUE_APP_FRESHCHAT_HOST,
    siteId: process.env.VUE_APP_FRESHCHAT_SITE,
  })
}
// eslint-disable-next-line
function initialize(i, t) {
  var e
  // eslint-disable-next-line no-unused-expressions
  i.getElementById(t)
    ? initFreshChat()
    : (((e = i.createElement('script')).id = t),
      (e.async = !0),
      (e.src = 'https://wchat.freshchat.com/js/widget.js'),
      (e.onload = initFreshChat),
      i.head.appendChild(e))
}
function initiateCall() {
  initialize(document, 'freshchat-js-sdk')
}
window.addEventListener
  ? window.addEventListener('load', initiateCall, !1)
  : window.attachEvent('load', initiateCall, !1)
